import { FactionRampBonus, FactionType } from "~/business";
import { Colors } from "~/jsx/theme";
import { Duration, transition } from "~/jsx/theme/Transition";
import { XFactionRampSvg, XFactionVictoryPoint, XVictoryPointSvg } from "./svg";
import { XAgentEffect } from "./XAgentEffect";
import { XPlayerIcon } from "./XPlayerIcon";

export type XCubeLevel = {
  playerId: string;
  level: number;
};

export const XFactionRamp = ({
  faction,
  cubeLevels,
  hasPoint,
}: {
  faction: FactionType;
  cubeLevels: XCubeLevel[];
  hasPoint: boolean;
}) => {
  const { main: darkColor } = Colors.faction[faction];
  const cubeSize = 18;
  const stepHeight = 29;
  const zeroStepHeight = 29;

  const rampBonus = FactionRampBonus[faction];
  return (
    <div style={{ position: "relative", width: "fit-content" }}>
      <XFactionRampSvg height={192} color={darkColor} />
      {hasPoint && (
        <div
          style={{
            position: "absolute",
            top: 8,
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <XFactionVictoryPoint faction={faction} width={56} />
        </div>
      )}
      <div
        style={{
          position: "absolute",
          width: "100%",
          bottom: zeroStepHeight + stepHeight + 8,
          left: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <XVictoryPointSvg width={18} />
      </div>
      <div
        style={{
          position: "absolute",
          top: stepHeight * 2.08,
          left: 4,
        }}
      >
        <XAgentEffect
          effectDescription={rampBonus}
          width={rampBonus.methodName === "solaris" ? 20 : 16}
          context="card"
        />
      </div>
      <div
        style={{
          position: "absolute",
          bottom: 0,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-end",
        }}
      >
        {cubeLevels.map(({ playerId, level }, index) => {
          const horizontalCorrection =
            (index !== 0 && index !== cubeLevels.length - 1) ||
            cubeLevels.length < 3
              ? 5
              : 0;
          const bottom =
            level === 0
              ? 2
              : (level - 1) * stepHeight +
                zeroStepHeight +
                horizontalCorrection;
          return (
            <div
              key={playerId}
              style={{
                marginBottom: bottom,
                transition: transition({ durationInMs: Duration.Long }),
              }}
            >
              <XPlayerIcon width={cubeSize} playerId={playerId} />
            </div>
          );
        })}
      </div>
    </div>
  );
};
